import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import s from './LoadingGeneration.module.css';
import shape1 from '../../../assets/img/shape7.svg'
import shape2 from '../../../assets/img/shape5.svg'
import shape3 from '../../../assets/img/shape3.svg'
import character from '../../../assets/img/character5.svg'
import loading_text from '../../../assets/img/loading.svg'
const LoadingGeneration: React.FC = () => {


    return ReactDOM.createPortal(
        <div className={s.modalOverlay}>

            <div className={s.modal}>
            <div className={s.tip}>
                <p className={s.header}>💡 High-quality content pro tip:</p>
                <p className={s.text} style={{width:300,marginBottom:20}}>The more detailed your prompt, the better the output. But keep it organized and clear!</p>
                <p className={s.text}>- Set Clear Context & Role 🎭</p>
                <p className={s.text}>- Be Specific About Format 📝</p>
                <p className={s.text}> - Define Key Objective 🎯</p>
                <p className={s.text}> - Include a Call-To-Action ✅</p>
            </div>
                <div className={s.background}>
                    <img src={shape1} className={s.shape1}/>
                    <img src={shape2} className={s.shape2}/>
                    <img src={shape3} className={s.shape3}/>
                </div>
                <div className={s.character_container}>
                    <img src={character} className={s.character}/>
                    <img src={loading_text} className={s.loading}/>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root') || document.body
    );
    };

export default LoadingGeneration;
